import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ToggleComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ToggleComponent implements OnInit, ControlValueAccessor {
  @Input() checked: boolean = false;
  @Input() name?: string;
  @Input() disabled: boolean = false;
  @Input() customClass: string = '';
  @Input() readOnly: boolean = false;
  @Input() labelPosition: 'after' | 'before' = 'before';

  @Output() inputChange = new EventEmitter<any>();
  @Output() change = new EventEmitter<boolean>();

  onChange = (value: any) => {};
  onTouch = () => {};

  ngOnInit(): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(value: any): void {
    this.checked = value;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onchange(event: any): void {
    this.checked = event;

    this.onChange(this.checked);
    this.onTouch();

    this.inputChange.emit(this.checked);
    this.change.emit(this.checked);
  }
}
